import { Component, OnDestroy } from '@angular/core';
import { WrapperPageComponent } from "../../component/wrapper/page-wrapper.component";
import { ActivatedRoute, NavigationEnd, Router, RouterLink, RouterOutlet } from '@angular/router';
import { filter, lastValueFrom, map, pipe, Subject, Subscription, switchMap, take, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import { listingsFeature, ListingsPageActions } from '../../store/listings.store';
import { ListingService } from '../../services/listing.service';
import { getListing } from '@dataconnect/account';
import { ListingPublic } from '../../../../globalTypes/listings.types';
import { accountFeature } from '../../store/account.store';
import { LocationPublic } from '../../../../globalTypes/account.types';
import { MatIcon } from "@angular/material/icon";
import { LocationWarning } from "../../component/layout/element/location.warning";

@Component({
  selector: 'msh-manage-listing',
  imports: [WrapperPageComponent, RouterOutlet, LocationWarning],
  template: `
    <msh-location-warning [isListing]="true"></msh-location-warning>
    <msh-page-wrapper
      [entityId]="listingId"
      [page]="'manageListing'"
      [disabledList]="disabledItemList"
    >
        <router-outlet />
    </msh-page-wrapper>
  `,
  styles: `
:host { height: 100%; display: flex; flex-direction: column; flex-grow:1; }`
})
export class ManageListingComponent implements OnDestroy {
  listingId = ''
  private routerSubscription: Subscription | undefined;
  disabledItemList: string[] = []
  destroy$ = new Subject<void>();
  disabledCount = ['photos','details','price-stock','delivery','status'];

  constructor(
    private store: Store,
    private route: ActivatedRoute,
    private router: Router,
    private listingService: ListingService,
  ){
    this.routerSubscription = this.router.events.pipe(
      takeUntil(this.destroy$),
      filter((event) => event instanceof NavigationEnd),
      map(() => this.route),
      map((route) => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      switchMap((route) => route.url) // Or route.params, route.data, etc.
    ).subscribe((urlSegments) => {
      const page = urlSegments[0].path;
      this.listingId = urlSegments[1].path;
      console.log('Child route changed:', urlSegments.map(segment => segment.path).join('/'));
      this.buildPage(page);
    });
  }
  async buildPage(page: string): Promise<void> {
    // check ngrx listing
    let rxListing = await lastValueFrom(this.store.select(listingsFeature.selectListing).pipe(take(1)));
    // if navigated to "new" set up page accordingly
    if(this.listingId === 'new' ){
      const deleteCount = this.disabledCount.findIndex(p=>p===page);
      this.disabledItemList = ["Details", "Price & Stock", "Delivery", "Status"]
      this.disabledItemList.splice(0, deleteCount);
      console.log({deleteCount, disabledItemList: this.disabledItemList})
      // this.store.dispatch(ListingsPageActions.clearListing())
    }
    // if no rx listing or if rx listing id doesn't match url listing id clear rx listing
    if(rxListing && rxListing.id && this.listingId !== 'new' && this.listingId !== rxListing.id) {
      this.store.dispatch(ListingsPageActions.clearListing())
      rxListing = null;
    }
    // if no rx listing, or if it was cleared, load the listing or make new one
    if(!rxListing || !rxListing.id) {
      let listing!: ListingPublic | Partial<ListingPublic>
      if(!!this.listingId && this.listingId !== 'new' && this.listingId !== ''){
        listing = (await getListing({ listingId: this.listingId})).data.listings[0] as ListingPublic;
        console.log({listing})
      }
      if(!listing){
        try{
          await lastValueFrom(this.store.select(accountFeature.selectLocation).pipe(filter(l=>!!l), take(1)))
          listing = await this.listingService.createBlankListing();
        }catch(e: any){
          console.error(e.message || "Error creating listing")
        }
      }
      this.store.dispatch(ListingsPageActions.progressListing({listing}))
    } else {
      this.listingId = rxListing.id;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}